export const cleanUserName = (userName, companyName) => {
  if (!userName) return '';
  
  let cleaned = userName;

  // 1. Remove companyName as a whole if it matches (case-insensitive)
  if (companyName) {
    const escapedCompanyName = companyName.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    const regex = new RegExp(`\\b${escapedCompanyName}\\b`, 'gi');
    cleaned = cleaned.replace(regex, '');
  }

  // 2. Tokenize company name and strip brand words & common company suffixes
  const stopWords = new Set([
    'pvt', 'ltd', 'lmt', 'limited', 'private', 'technologies', 'technology', 
    'services', 'co', 'corp', 'corporation', 'inc', 'incorporated', 'solutions', 'sys', 'systems'
  ]);

  const companyWords = new Set();
  if (companyName) {
    companyName
      .toLowerCase()
      .split(/[^a-zA-Z0-9]+/)
      .forEach(token => {
        if (token && token.length > 1) {
          companyWords.add(token);
        }
      });
  }

  // Tokenize the username and filter out words that are stopWords or in companyWords
  const userTokens = cleaned
    .split(/\s+/)
    .filter(token => {
      const normalized = token.toLowerCase().replace(/[^a-zA-Z0-9]+/g, '');
      if (!normalized) return false;
      if (stopWords.has(normalized)) return false;
      if (companyWords.has(normalized)) return false;
      return true;
    });

  // Reconstruct username
  cleaned = userTokens.join(' ').trim();

  // If the name is completely empty or just common noise, return a fallback or the original name
  return cleaned || userName;
};
